import React from "react";
import './account-lock.css';

const AccountLock = () => {

  return<div className="account-lock">
    Аккаунт заблокирован
  </div>
}

export default AccountLock;